import { Address } from 'api/public/place/types';
import { useTypedSelector } from 'shared/redux/store';
import { selectMyLocation } from '../slice';

export const useMyLocation = (): Address | undefined => {
  return useTypedSelector(selectMyLocation);
};
